/* eslint-disable */
/**
 * 此文件用于定义自定义字段
 */
const baseUrl = process.env.BASE_URL;
const goog = window.goog;
const Blockly = window.Blockly;
const isMobile = goog.userAgent.MOBILE || goog.userAgent.ANDROID || goog.userAgent.IPAD;
goog.provide('Blockly.CustomMediaField');
goog.provide('Blockly.JointAngleControll');
goog.provide('Blockly.RobotEventField');
goog.require('Blockly.Field');
function isParent(obj, parentObj) {
    while(obj != undefined && obj != null && !obj.classList.contains('blocklyWorkspace')) {
        if(obj == parentObj) {
            return true;
        }
        obj = obj.parentNode;
    }
    return false;
}
function isIconGroup(obj){
    while(obj != undefined && obj != null && !obj.classList.contains('blocklyWorkspace')) {
        if(obj.classList.contains('blocklyIconGroup')) {
            return true;
        }
        obj = obj.parentNode;
    }
    return false;
}
export default function (tokenInfo) {
    //blockly原生id生成特殊字符，修改为普通字符
    Blockly.utils.genUid.soup_ = "-_ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    // 根据工作区宽度动态计算blockly文本最大显示长度
    Blockly.Field.prototype.getMaxDisplayLength = function(){
        let maxDisplayLength = 44
        let spaceWidth = document.body.offsetWidth
        if(Blockly.getMainWorkspace() && Blockly.getMainWorkspace().svgBackground_){
            spaceWidth = Blockly.getMainWorkspace().svgBackground_.getBBox().width
        }
        if(spaceWidth < 640){
            maxDisplayLength = 20
        } else if(spaceWidth < 960){
            maxDisplayLength = 26
        } else if(spaceWidth < 1024){
            maxDisplayLength = 32
        } else if(spaceWidth < 1280){
            maxDisplayLength = 38
        }
        return maxDisplayLength
    };
    //上传素材字段
    (function uploadMaterial() {
        Blockly.CustomMediaField = function (a) {
            this.queryToken = `?token=${tokenInfo.token}&customerId=${tokenInfo.customerId}`;
            this.sourceBlock_ = null;
            let {
                value,
                width,
                height,
                alt,
                mediaType,
                tooltip,
                icon,
                flipRtl,
                showText = false
            } = a;
            this.height_ = Number(height);
            this.width_ = Number(width);
            this.size_ = new goog.math.Size(this.width_, this.height_ + 2 * Blockly.BlockSvg.INLINE_PADDING_Y);
            this.flipRtl_ = !!flipRtl;
            this.tooltip_ = Blockly.utils.replaceMessageReferences(tooltip);
            this.mediaType = mediaType;
            this.showText_ = showText;
            this.setValue(Blockly.utils.replaceMessageReferences(value));
            this.setText(Blockly.utils.replaceMessageReferences(alt));
            this.icon_ = icon;
            this.defaultIcon_ = baseUrl + "static/js/blockly/media/nuwa/custom_media_icon_default.png";
        };
        goog.inherits(Blockly.CustomMediaField, Blockly.Field);

        Blockly.CustomMediaField.fromJson = function (a) {
            var defaultOption = {
                value: "",
                width: 24,
                height: 24,
                alt: "",
                mediaType: "",
                tooltip: "",
                icon: "",
                flipRtl: false
            };
            a = Object.assign(defaultOption, a);
            return new Blockly.CustomMediaField(a);
        };
        Blockly.CustomMediaField.prototype.EDITABLE = true;
        Blockly.CustomMediaField.prototype.init = function () {
            if (!this.fieldGroup_) {
                this.fieldGroup_ = Blockly.utils.createSvgElement("g", {}, null);
            }
            if (!this.visible_) {
                this.fieldGroup_.style.display = "none";

            }
            this.imageElement_ = Blockly.utils.createSvgElement("image", {
                height: this.height_ + "px",
                width: this.width_ + "px"
            }, this.fieldGroup_);
            if(this.showText_){
                this.textElement_ = Blockly.utils.createSvgElement("text", {
                    class: "blocklyText media-name",
                    x: this.width_ + Blockly.BlockSvg.INLINE_PADDING_Y ,
                    y: 12.5,
                    "font-size": "11px"
                }, this.fieldGroup_);
            }
            this.setValue(this.value);
            this.setText(this.text_);
            this.sourceBlock_.getSvgRoot().appendChild(this.fieldGroup_);
            this.tooltip_ ? this.imageElement_.tooltip = this.tooltip_ : this.setTooltip(this.sourceBlock_);
            Blockly.Tooltip.bindMouseEvents(this.imageElement_);
            this.maybeAddClickHandler_();
        };
        Blockly.CustomMediaField.prototype.dispose_ = function () {
            this.fieldGroup_ && (Blockly.utils.removeNode(this.fieldGroup_), this.fieldGroup_ = null);
            this.imageElement_ = null
        };
        Blockly.CustomMediaField.prototype.maybeAddClickHandler_ = function () {
            this.clickHandler_ && (this.mouseDownWrapper_ = Blockly.bindEventWithChecks_(this.fieldGroup_, "mousedown", this,
                this.clickHandler_))
        };
        Blockly.CustomMediaField.prototype.setTooltip = function (a) {
            this.tooltip_ = a;
            this.imageElement_ && (this.imageElement_.tooltip = a)
        };
        Blockly.CustomMediaField.prototype.getValue = function () {
            return this.value;
        };
        Blockly.CustomMediaField.prototype.setValue = function (a) {
            if (null !== a && undefined !== a) {
                this.value = a;
                this.screenshot = "";
                if (typeof Blockly.getMaterialByIndex === "function") {
                    let mediaData = Blockly.getMaterialByIndex(this.value);
                    if (mediaData) {
                        this.screenshot_ = mediaData.screenshot || mediaData.url || "";
                    }
                }
                if (this.imageElement_) {
                    var iconSrc = this.icon_ || this.defaultIcon_;
                    if (["audio", "record"].includes(this.mediaType)) {
                        this.imageElement_.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", iconSrc);
                    } else {
                        this.imageElement_.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", this.screenshot_ ? this.screenshot_ + this.queryToken : iconSrc);
                    }
                }
                if(this.textElement_){
                    this.textElement_.textContent = a;
                }
            }
            if(this.fieldGroup_ && this.showText_){
                setTimeout(() => {
                    this.forceRerender();
                })
            }
        };
        Blockly.CustomMediaField.prototype.getFlipRtl = function () {
            return this.flipRtl_
        };
        Blockly.CustomMediaField.prototype.setText = function (a) {
            null !== a && (this.text_ = a, this.imageElement_ && this.imageElement_.setAttribute("alt", a || ""))
        };
        Blockly.CustomMediaField.prototype.render_ = function () { };
        Blockly.CustomMediaField.prototype.forceRerender = function () {
            this.updateWidth();
            this.sourceBlock_&&this.sourceBlock_.rendered&&(this.sourceBlock_.render(),this.sourceBlock_.bumpNeighbours_())
        };
        Blockly.CustomMediaField.prototype.updateWidth = function () {
            const textWidth = this.showText_ ? (Blockly.Field.getCachedWidth(this.textElement_) + Blockly.BlockSvg.INLINE_PADDING_Y) : 0;
            this.size_.width = this.width_ + textWidth + 2 * Blockly.BlockSvg.INLINE_PADDING_Y;
            this.fieldGroup_.setAttribute("width", this.size_.width)
        };
        Blockly.CustomMediaField.prototype.showEditor_ = function () {
            this.clickHandler_ && this.clickHandler_(this)
        };
        Blockly.Field.register("field_custom_media", Blockly.CustomMediaField);
    })();
    //图文下拉菜单
    (function imgDropdown() {
        Blockly.WidgetDiv.calculateY_ = function (a, b, c) {
            var top;
            var div = this.DIV;
            div.classList.remove("up");
            div.classList.remove("down");
            if (b.bottom + c.height >= a.bottom) {
                top = b.top - c.height - 15;
                div.classList.add("down");
            } else {
                top = b.bottom + 15;
                div.classList.add("up");
            }
            return top;
        }
        Blockly.WidgetDiv.calculateX_ = function (a, b, c, d) {
            b = Math.min(b.left - 0.5 * (c.width + b.left - b.right), a.right - c.width);
            return Math.max(b, a.left)
        }
        
        Blockly.FieldDropdown.fromJson = function (a) {
            var dropdown = new Blockly.FieldDropdown(a.options);
            var bg = Blockly.utils.replaceMessageReferences(a.bg);
            dropdown.setBg(bg);
            let placeholder_ = Blockly.utils.replaceMessageReferences(a.placeholder || "%{BKY_NUWA_DROPDOWN_PLACEHOLDER}");
            dropdown.placeholder_ = placeholder_;
            if(!dropdown.text_){
                dropdown.text_ = placeholder_;
            }
            if(a.value !== undefined && !!dropdown.getOptions().find(item => item[1] === a.value)){
                dropdown.setValue(a.value);
            }
            return dropdown;
        };
        Blockly.FieldDropdown.prototype.setBg = function (colour) {
            this.bg_ = colour;
        };
        Blockly.FieldDropdown.prototype.init = function () {
            this.setBg(this.bg_ || (this.sourceBlock_ ? this.sourceBlock_.getColour() : "#eaeaea"));
            this.fieldGroup_ || (this.arrow_ = Blockly.utils.createSvgElement("tspan", {}, null), this.arrow_.appendChild(document.createTextNode(this.sourceBlock_.RTL ? Blockly.FieldDropdown.ARROW_CHAR + " " : " " + Blockly.FieldDropdown.ARROW_CHAR)), Blockly.FieldDropdown.superClass_.init.call(this))
        };
        Blockly.FieldDropdown.prototype.setValue = function (a) {
            if (null !== a) {
                let optionItem;
                for (var b = this.getOptions(), c = 0; c < b.length; c++){
                    if(typeof b[c][1] === "function"){
                        let value = b[c][1]();
                        if (value == a) {
                            optionItem = b[c][0];
                            break;
                        }
                    } else {
                        if (b[c][1] == a) {
                            optionItem = b[c][0];
                            break;
                        } 
                    }
                }
                if(!!optionItem){
                    if(a !== this.value_){
                        this.sourceBlock_ && Blockly.Events.isEnabled() && Blockly.Events.fire(new Blockly.Events.BlockChange(this.sourceBlock_, "field", this.name, this.value_, a));
                    }
                    this.value_ = a;
                    if("object" == typeof optionItem){
                        this.imageJson_ = optionItem;
                        this.text_ = optionItem.alt
                    } else {
                        this.imageJson_ = null, this.text_ = Blockly.utils.replaceMessageReferences(optionItem)
                    }
                } else {
                    this.value_ = "";
                    this.text_ = this.placeholder_;
                }
                this.forceRerender();
            }
        };
        Blockly.FieldDropdown.prototype.createMenu_ = function () {
            var a = new goog.ui.Menu;
            a.setRightToLeft(this.sourceBlock_.RTL);
            for (var b = this.getOptions(), c = 0; c < b.length; c++) {
                var d = b[c][0],
                    e = b[c][1],
                    func = b[c][2];
                if ("object" == typeof d) {
                    var span = document.createElement("span");
                    span.className = "nuwaBlocklyDropItemContent";
                    span.style.height = d.height + "px";
                    span.style.lineHeight = d.height + "px";
                    var f;
                    if(d.src && d.src[0] === "#"){
                        let svgNs = "http://www.w3.org/2000/svg";
                        f = document.createElementNS(svgNs, "svg");
                        f.setAttribute("width", d.width);
                        f.setAttribute("height", d.height);
                        f.setAttribute("class", "item-image");
                        let use = document.createElementNS(svgNs, "use");
                        use.setAttributeNS("http://www.w3.org/1999/xlink","xlink:href", d.src);
                        f.appendChild(use);
                    } else {
                        var f = new Image(d.width, d.height);
                        if(d.src){
                            f.src = d.src;
                            f.alt = d.alt || "";
                        }
                    }
                    if(d.style){
                        Object.keys(d.style).forEach(key => {
                            f.style[key] = d.style[key];
                        })
                    }
                    span.appendChild(f);
                    if (d.alt) {
                        var label = Blockly.utils.replaceMessageReferences(d.alt);
                        span.innerHTML += '<span class="nuwaDropdownItemLabel" style="line-">' + label + '</span>';
                    }
                    if(func){
                        let funcDom = document.createElement("span");
                        funcDom.className = "nuwaDropdownItemFunc";
                        funcDom.innerHTML = Blockly.utils.replaceMessageReferences(func[0]);
                        funcDom.style.top = `${(d.height - 18) / 2}px`;
                        if(func[1] && typeof func[1] === "function"){
                            let _thisField = this;
                            funcDom.onmousedown = (function(option){
                                return function(e){
                                    e.stopPropagation();
                                    func[1](_thisField, option);
                                }
                            })(b[c])
                        }
                        span.appendChild(funcDom);
                    }
                    d = span;
                } else if(typeof d === "string") {
                    d = Blockly.utils.replaceMessageReferences(d);
                }
                if(typeof e === "function" && e() === this.value_){
                    e = this.value_;
                }
                d = new goog.ui.MenuItem(d);
                d.setRightToLeft(this.sourceBlock_.RTL);
                d.setValue(e);
                d.setCheckable(!0);
                d.setChecked(e == this.value_);
                a.addChild(d, !0);
                if(["nuwa_menu_title", "nuwa_menu_small"].includes(e)){
                    d.setCheckable(false);
                    var key = e.replace("nuwa_menu_", "");
                    d.element_ && (d.element_.classList.add("goog-option"),d.element_.classList.add("goog-menu-" + key))
                }
            }
            
            var el = a.getElement();
            el.classList.add("nuwaBLocklyDropdown");
            el.style.background = this.bg_;
            this.nuwaMenu = a;
            return a
        };
        Blockly.FieldDropdown.prototype.addActionListener_ = function (a) {
            var b = this;
            goog.events.listen(a, goog.ui.Component.EventType.ACTION, function (a) {
                if (a = a.target) {
                    var value = a.getValue();
                    if (typeof value === "function") {
                        value(b);
                    } else if(!["nuwa_menu_title", "nuwa_menu_small"].includes(value)) {
                        b.onItemSelected(b, a);
                        Blockly.WidgetDiv.hideIfOwner(b);
                        Blockly.Events.setGroup(!1)
                    }
                }
            })
        };
        Blockly.FieldDropdown.prototype.getAnchorDimensions_ = function () {
            var a = this.getScaledBBox_();
            return a
        }
        Blockly.FieldDropdown.prototype.positionMenu_ = function (a) {
            var b = Blockly.utils.getViewportBBox(),
                c = this.getAnchorDimensions_();
            this.createWidget_(a);
            var d = Blockly.utils.uiMenu.getSize(a),
                e = Blockly.FieldDropdown.MAX_MENU_HEIGHT_VH * document.documentElement.clientHeight;
            d.height > e && (d.height = e);
            this.sourceBlock_.RTL && Blockly.utils.uiMenu.adjustBBoxesForRTL(b, c, d);
            Blockly.WidgetDiv.positionWithAnchor(b, c, d, this.sourceBlock_.RTL);
            var el = a.getElement();
            var arrow = document.createElement("div");
            arrow.style.left = (el.offsetWidth - 20) * 0.5 + "px";
            arrow.className = "nuwaDropdownArrow";
            el.parentNode.appendChild(arrow);
            if (Blockly.WidgetDiv.DIV.classList.contains("down")) {
                arrow.style.top = el.offsetHeight - 3 + "px";
                arrow.style.borderTopColor = this.bg_;
            } else {
                arrow.style.top = -14 + "px";
                arrow.style.borderBottomColor = this.bg_;
            }
            a.getElement().focus()
        };
        Blockly.FieldDropdown.prototype.renderSelectedImage_ = Blockly.FieldDropdown.prototype.renderSelectedText_;

        Blockly.FieldDropdown.validateOptions_ = function(a) {
            if (!Array.isArray(a))
                throw TypeError("FieldDropdown options must be an array.");
            for (var b = !1, c = 0; c < a.length; ++c) {
                var d = a[c];
                if(Array.isArray(d)){
                    if(typeof d[1] !== "string" && typeof d[1] !== "function"){
                        b = true;
                        console.error("Invalid option[" + c + "]: Each FieldDropdown option id must be a string or function. Found " + d[1] + " in: ", d);
                    } else if("string" != typeof d[0] && "string" != typeof d[0].src){
                        b = true;
                        console.error("Invalid option[" + c + "]: Each FieldDropdown option must have a string label or image description. Found" + d[0] + " in: ", d);
                    }
                } else {
                    b = true;
                    console.error("Invalid option[" + c + "]: Each FieldDropdown option must be an array. Found: ", d);
                }
            }
            if(b){
                throw TypeError("Found invalid FieldDropdown options.");
            }
        }
    })();
    //关节角度调整控件
    (function jointControll() {
        Blockly.JointAngleControll = function (data) {
            let {
                value,
                getLabel,
                preValue
            } = data;
            this.fieldoptions = data;
            this.marker_ = Blockly.utils.createSvgElement("tspan", {}, null);
            this.marker_.appendChild(document.createTextNode("\u00b0"));
            this.value_ = value;
            this.initValue = value;
            this.preValue = preValue;
            this.text_ = getLabel(value);
            this.getLabel = getLabel;
            this.size_=new goog.math.Size(0,Blockly.BlockSvg.MIN_BLOCK_Y);
        };
        Blockly.JointAngleControll.fromJson = function (data) {
            let defaultData = {
                rotateMin: 0,
                rotateMax: 360,
                value: 0,
                bg: null,
                symbol: null,
                transform: null,
                initRotate: 0,//初始化时指针旋转的角度
                initAngle: 0,//初始化时指针相对于x轴正方向的夹角
                clockWise: 1,
                preValue: "",
                getLabel: function(text){
                    return text;
                },
                fixInputValue: function(value){
                    return value;
                }
            };
            data = Object.assign(defaultData, data);
            return new Blockly.JointAngleControll(data);
        };
        goog.inherits(Blockly.JointAngleControll, Blockly.FieldTextInput);
        Blockly.JointAngleControll.prototype.render_ = function () {
            if (this.visible_ && this.textElement_) {
                this.textElement_.textContent = this.text_;
                if (this.sourceBlock_.RTL) {
                    this.textElement_.insertBefore(this.marker_, this.textElement_.firstChild);
                } else {
                    this.textElement_.appendChild(this.marker_);
                }
                this.updateWidth();
                this.resizeEditor_();
            } else {
                this.size_.width = 0;
            }
            this.sourceBlock_ && this.sourceBlock_.rendered && this.sourceBlock_.render(false);
        };
        Blockly.JointAngleControll.prototype.showEditor_ = function () {
            if(this.sourceBlock_){
                Blockly.showJointAnglePopper(this);
            }
        };
        //设置当前值
        Blockly.JointAngleControll.prototype.setValue = function(value){
            if(typeof value === "string"){
                value = value.replace(this.preValue, "");
            }
            value = Number(value);
            let oldValue = this.value_;
            this.value_ = value;
            this.text_ = this.getLabel(value);
            if (this.sourceBlock_ && Blockly.Events.isEnabled()) {
                Blockly.Events.fire(new Blockly.Events.BlockChange(this.sourceBlock_, "field", this.name, oldValue, value));
            }
            this.render_();
        };
        //获取构造xml、js code用的值
        Blockly.JointAngleControll.prototype.getValue = function(){
            return this.preValue + this.value_;
        };
        //获取用于输入框显示的值
        Blockly.JointAngleControll.prototype.getLabel = function(){
            if(typeof this.getLabel === "function"){
                return this.getLabel(this.value_);
            } else if(typeof this.getLabel === "object" || !this.getLabel){
                return "";
            }
            return this.getLabel;
        };
        //较正输入框输入
        Blockly.JointAngleControll.prototype.fixInputValue = function(value){
            if(typeof this.fixInputValue === "function"){
                return this.fixInputValue(value);
            } else if(typeof this.fixInputValue === "object" || !this.fixInputValue){
                return this.getLabel();
            }
            return this.fixInputValue;
        },
        Blockly.Field.register("field_joint_angle", Blockly.JointAngleControll);
    })();
    //颜色选择器
    (function colorPicker() {
        Blockly.FieldColour.DEFAULT_COLUMNS = 5;
        Blockly.FieldColour.CUSTOM_COLUMNS = 8;
        Blockly.FieldColour.COLOURS = [
            "#ffffff #fff100 #ff9e00 #ff0000 #ff00c5 #00e6ff #33ff33 #009900 #0019ff #af00ff".split(" "),
            "#ffffff #ffcccc #ffcc99 #ffffcc #99ff99 #99ffff #90acff #ffccff #cccccc #ff6666 #ff9966 #feff34 #66ff99 #32ffff #4876ff #ff99ff #999999 #cc0000 #ff6600 #ffcc00 #33cc00 #00cccc #2357f7 #cc33cb #333333 #660000 #993300 #666600 #016600 #326666 #080099 #663266".split(" ")
        ];
        Blockly.FieldColour.prototype.showEditor_ = function () {
            Blockly.DropDownDiv.hideWithoutAnimation();
            Blockly.DropDownDiv.clearContent();
            var a = this.createWidget_();
            a.className = "";
            Blockly.DropDownDiv.getContentDiv().appendChild(a);
            Blockly.DropDownDiv.setColour("#444444", "transparent");
            Blockly.DropDownDiv.showPositionedByField(this);
            Blockly.DropDownDiv.DIV_.classList.add("nuwaColourPicker");
            Blockly.FieldColour.onUpWrapper_ = Blockly.bindEvent_(a, "mouseup", this, this.onClick_)
        };
        Blockly.FieldColour.prototype.createWidget_ = function () {
            var defaultColours = this.defaultColours_ || Blockly.FieldColour.COLOURS[0];
            var customColours = this.customColours_ || Blockly.FieldColour.COLOURS[1];
            var defaultColumns = this.defaultColumns_ || Blockly.FieldColour.DEFAULT_COLUMNS;
            var customColumns = this.customColumns_ || Blockly.FieldColour.CUSTOM_COLUMNS;
            var color = this.getValue();
            var table = [document.createElement("div"), document.createElement("div")];
            table[0].className = "blocklyColourTable defaultTable";
            table[1].className = "blocklyColourTable customTable";
            var li, ul, div, content;
            for (var i = 0, len1 = Math.ceil(defaultColours.length / defaultColumns); i < len1; i++) {
                ul = document.createElement("ul");
                for (var j = 0; j < defaultColumns; j++) {
                    var index = i * defaultColumns + j;
                    li = document.createElement("li");
                    if (defaultColours[index]) {
                        div = document.createElement("div");
                        div.className = "colourpickerItem";
                        div.title = defaultColours[index];
                        div.label = defaultColours[index];
                        div.innerHTML = '<div style="background-color: ' + defaultColours[index] + '"></div>';
                        if (color === defaultColours[index]) {
                            div.className = "colourpickerItem blocklyColourSelected";
                        }
                        li.appendChild(div);
                    }
                    ul.appendChild(li);
                }
                table[0].appendChild(ul);
            }
            for (var i = 0, len1 = Math.ceil(customColours.length / customColumns); i < len1; i++) {
                ul = document.createElement("ul");
                for (var j = 0; j < customColumns; j++) {
                    var index = i * customColumns + j;
                    li = document.createElement("li");
                    if (customColours[index]) {
                        div = document.createElement("div");
                        div.className = "colourpickerItem";
                        div.title = customColours[index];
                        div.label = customColours[index];
                        div.innerHTML = '<div style="background-color: ' + customColours[index] + '"></div>';
                        if (color === customColours[index]) {
                            div.className = "colourpickerItem blocklyColourSelected";
                        }
                        li.appendChild(div);
                    }
                    ul.appendChild(li);
                }
                table[1].appendChild(ul);
            }
            this.pickerContent_ = content = document.createElement("div");
            content.className = "blocklyColourPickerContent";
            content.appendChild(table[0]);
            content.appendChild(table[1]);

            return content;
        }
        Blockly.FieldColour.widgetDispose_ = function () {
            Blockly.DropDownDiv.DIV_.classList.remove("nuwaColourPicker");
            Blockly.FieldColour.onUpWrapper_ && Blockly.unbindEvent_(Blockly.FieldColour.onUpWrapper_);
            Blockly.Events.setGroup(!1)
        }
        Blockly.FieldColour.prototype.onClick_ = function (a) {
            (a = a.target) && !a.label && (a = a.parentNode);
            a = a && a.label;
            Blockly.WidgetDiv.hide();
            this.sourceBlock_ && (a = this.callValidator(a));
            null !== a && this.setValue(a)
            var selectedColor = Blockly.DropDownDiv.DIV_.querySelector(".colourpickerItem.blocklyColourSelected");
            selectedColor && selectedColor.classList.remove("blocklyColourSelected");
            selectedColor = Blockly.DropDownDiv.DIV_.querySelector(".colourpickerItem[title='" + a + "']");
            selectedColor && selectedColor.classList.add("blocklyColourSelected");
        }
    })();
    //机器人事件控件
    (function robotEvent() {
        Blockly.RobotEventField = function (name) {
            this.width_ = 0;
            this.height_ = 16;
            this.name = name;
            this.valueStorage_ = {};
            this.spellcheck_ = true;
            this.size_ = new goog.math.Size(this.width_, this.height_ + 2 * Blockly.BlockSvg.INLINE_PADDING_Y);
        };
        // goog.inherits(Blockly.RobotEventField, Blockly.FieldTextInput);
        goog.inherits(Blockly.RobotEventField, Blockly.FieldDropdown);

        Blockly.RobotEventField.fromJson = function (a) {
            let { name } = a;
            return new Blockly.RobotEventField(name);
        };
        Blockly.RobotEventField.prototype.EVENT_NAME = "";
        Blockly.RobotEventField.prototype.EVENT_VALUE = "";
        Blockly.RobotEventField.prototype.EVENT_NAME_WIDTH = 2 * Blockly.BlockSvg.INLINE_PADDING_Y + 24;
        Blockly.RobotEventField.prototype.EVENT_VALUE_WIDTH = 2 * Blockly.BlockSvg.INLINE_PADDING_Y + 24;
        Blockly.RobotEventField.prototype.SHOW_ROBOT_FAMILIES = false//是否顯示機器人上的家人清單
        Blockly.RobotEventField.prototype.SHOW_MULTI_ROBOTS_TIP = false//是否顯示多台連線提示
        //用於顯示機器人家人清單的標題
        Blockly.RobotEventField.prototype.ROBOT_FAMILY_OPTION = [
            "%{BKY_NUWA_FMILIES_OPTION_MY_FAMILIES}",
            "nuwa_menu_title"
        ]
        //臨時家人清單的菜單標題單
        Blockly.RobotEventField.prototype.TEMP_FAMILY_OPTION = [
            "%{BKY_NUWA_FMILIES_OPTION_CUSTOM_NICKNAME}",
            "nuwa_menu_title"
        ]
        // 多台機器人連線提示
        Blockly.RobotEventField.prototype.MULTI_ROBOTS_TIP = [
            "%{BKY_NUWA_TEXT_MULTI_ROBOT_FAMILIES_TIP}",
            "nuwa_menu_small"
        ]
        //機器人家人清單為空時的提示
        Blockly.RobotEventField.prototype.ROBOT_FAMILY_EMPTY_TIP = [
            "%{BKY_NUWA_TEXT_ROBOT_FMILIES_EMPTY}",
            "nuwa_menu_small"
        ]
        //添加自定家人按鈕
        Blockly.RobotEventField.prototype.ADD_FAMILY_BUTTON = [{
            src: baseUrl + "static/js/blockly/media/nuwa/gra-addnickname.svg",
            width: 50,
            height: 50,
            alt: "%{BKY_NUWA_TEXT_ADD_FAMILIY_NICKNAME}"
        }, function (dropdown) {
            if(!dropdown){
                return "add_temp_families";
            }
            if(document.createEvent) {
                var event = document.createEvent("CustomEvent");
                event.initCustomEvent("addfamilies", true, true);
                document.body.dispatchEvent(event);
            } else if(document.createEventObject) {
                document.body.fireEvent("addfamilies");
            }
            Blockly.WidgetDiv.hideIfOwner(dropdown);
        }]
        Blockly.RobotEventField.OPTIONS = [
            {
                value: "TouchAction",
                label: "%{BKY_NUWA_ACTION_OPTION_TOUCHED}",
                type: "select",
                options: [
                    [{
                        src: baseUrl + "static/js/blockly/media/nuwa/select_options/touch/img_mc_touch_1_head.png",
                        width: 50,
                        height: 50,
                        alt:  Blockly.utils.replaceMessageReferences("%{BKY_NUWA_HEAD}")
                    }, "0"],
                    [{
                        src: baseUrl + "static/js/blockly/media/nuwa/select_options/touch/img_mc_touch_2_chest.png",
                        width: 50,
                        height: 50,
                        alt: Blockly.utils.replaceMessageReferences("%{BKY_NUWA_TUMMY}")
                    }, "1"],
                    [{
                        src: baseUrl + "static/js/blockly/media/nuwa/select_options/touch/img_mc_touch_3_lefthand.png",
                        width: 50,
                        height: 50,
                        alt: Blockly.utils.replaceMessageReferences("%{BKY_NUWA_LEFT_HAND}")
                    }, "3"],
                    [{
                        src: baseUrl + "static/js/blockly/media/nuwa/select_options/touch/img_mc_touch_4_righthand.png",
                        width: 50,
                        height: 50,
                        alt: Blockly.utils.replaceMessageReferences("%{BKY_NUWA_RIGHT_HAND}")
                    }, "2"],
                    [{
                        src: baseUrl + "static/js/blockly/media/nuwa/select_options/touch/img_mc_touch_6_leftcheek.png",
                        width: 50,
                        height: 50,
                        alt: Blockly.utils.replaceMessageReferences("%{BKY_NUWA_LEFT_CHEEK}")
                    }, "4"],
                    [{
                        src: baseUrl + "static/js/blockly/media/nuwa/select_options/touch/img_mc_touch_5_rightcheek.png",
                        width: 50,
                        height: 50,
                        alt: Blockly.utils.replaceMessageReferences("%{BKY_NUWA_RIGHT_CHEEK}")
                    }, "5"]
                ]
            },
            {
                value: "ListenAction",
                label: "%{BKY_NUWA_ACTION_OPTION_LISTEN}",
                type: "input"
            },
            {
                value: "MCFaceRecognitionAction",
                label: "%{BKY_NUWA_ACTION_OPTION_SEE}",
                type: "select",
                options: []
            },
            // {
            //     value: "WakeUpVoiceAction",
            //     label: "%{BKY_NUWA_ACTION_OPTION_WAKEUP}",
            //     type: null
            // },
            // {
            //     value: "PIRAction",
            //     label: "%{BKY_NUWA_ACTION_OPTION_FIND_SOMEONE}",
            //     type: null
            // }
        ];
        Blockly.RobotEventField.setFamilyOptions = function(families){
            let options = families.map(item => {
                let {value, label: alt, thumb: src, from} = item;
                return [{
                    src: src || baseUrl + "static/js/blockly/media/nuwa/gra-family-default.png",
                    width: 50,
                    height: 50,
                    alt: alt || Blockly.Msg.NUWA_UNNAME_NICKNAME
                }, value + ""];
            });
            let seeConfig = Blockly.RobotEventField.OPTIONS.find(item => item.value === "MCFaceRecognitionAction");
            if(seeConfig){
                seeConfig.options = options;
            }
        };
        Blockly.Field.register("field_robot_event", Blockly.RobotEventField);
        Blockly.RobotEventField.prototype.init = function () {
            this.colour_ = this.bg_ = this.sourceBlock_.getColour();
            if (!this.fieldGroup_) {
                this.fieldGroup_ = Blockly.utils.createSvgElement("g", {}, null);
                this.arrow_ = Blockly.utils.createSvgElement("tspan", {}, null);
                this.arrow_.appendChild(document.createTextNode(this.sourceBlock_.RTL ? Blockly.FieldDropdown.ARROW_CHAR + " " : " " + Blockly.FieldDropdown.ARROW_CHAR));
                this.arrow_.style.fill = this.colour_;
                if (!this.visible_) {
                    this.fieldGroup_.style.display = "none";
                }
            }
            this.eventNameGroup_ = Blockly.utils.createSvgElement("g", {
                transform: "translate(0, 0)",
                class: "blocklyEditableText"
            }, this.fieldGroup_);
            this.eventValueGroup_ = Blockly.utils.createSvgElement("g", {
                transform: "translate(" + (this.EVENT_NAME_WIDTH + Blockly.BlockSvg.SEP_SPACE_X) + ", 0)",
                class: "blocklyEditableText"
            }, this.fieldGroup_);
            this.eventNameRect_ = Blockly.utils.createSvgElement("rect", {
                rx: 4,
                ry: 4,
                x: 0,
                y: 0,
                height: this.height_,
                class: "eventNameRect"
            }, this.eventNameGroup_);
            this.eventValueRect_ = Blockly.utils.createSvgElement("rect", {
                rx: 4,
                ry: 4,
                x: 0,
                y: 0,
                height: this.height_,
                class: "eventValueRect"
            }, this.eventValueGroup_);
            this.eventNameElement_ = Blockly.utils.createSvgElement("text", {
                class: "blocklyText",
                x: Blockly.BlockSvg.INLINE_PADDING_Y,
                y: 12.5,
            }, this.eventNameGroup_);
            this.eventValueElement_ = Blockly.utils.createSvgElement("text", {
                class: "blocklyText",
                x: Blockly.BlockSvg.INLINE_PADDING_Y,
                y: 12.5,
            }, this.eventValueGroup_);
            this.sourceBlock_.getSvgRoot().appendChild(this.fieldGroup_);
            this.eventNameClickWrapper_ = Blockly.bindEvent_(this.eventNameGroup_, "mouseup", this, this.showEventNameSelect);
            this.eventValuClickWrapper_ = Blockly.bindEvent_(this.eventValueGroup_, "mouseup", this, this.onEventValueClick);
        };
        Blockly.RobotEventField.prototype.render_ = function () {
            let displayText = this.getLabel();
            this.eventNameElement_ && (this.eventNameElement_.textContent = Blockly.utils.replaceMessageReferences(displayText[0]), !this.sourceBlock_.RTL ? this.eventNameElement_.appendChild(this.arrow_.cloneNode(true)) : this.eventNameElement_.insertBefore(this.arrow_.cloneNode(true), this.eventNameElement_.firstChild));
            this.eventValueElement_ && (this.eventValueElement_.textContent = Blockly.utils.replaceMessageReferences(displayText[1]), this.valueInputType_ === "select" && (!this.sourceBlock_.RTL ? this.eventValueElement_.appendChild(this.arrow_.cloneNode(true)) : this.eventValueElement_.insertBefore(this.arrow_.cloneNode(true), this.eventValueElement_.firstChild)));
            if (this.valueInputType_ === null) {
                this.eventValueGroup_ && (this.eventValueGroup_.style.display = "none");
            } else {
                this.eventValueGroup_ && (this.eventValueGroup_.style.display = "block");
                if (this.valueInputType_ === "input") {
                    this.eventValueGroup_ && (this.eventValueGroup_.style.cursor = "text");
                } else {
                    this.eventValueGroup_ && (this.eventValueGroup_.style.cursor = "pointer");
                }
            }
            this.updateWidth();
            this.sourceBlock_ && this.sourceBlock_.rendered && this.sourceBlock_.render(false);
        };
        Blockly.RobotEventField.prototype.dispose_ = function () {
            this.eventNameClickWrapper_ && (Blockly.unbindEvent_(this.eventNameClickWrapper_));
            this.eventValuClickWrapper_ && (Blockly.unbindEvent_(this.eventValuClickWrapper_));
        };
        Blockly.RobotEventField.prototype.updateWidth = function () {
            if (!this.visible_) {
                return this.size_.width = 0;
            }
            let eventNameWidth = Math.max(this.EVENT_NAME_WIDTH, this.eventNameElement_ ? Blockly.Field.getCachedWidth(this.eventNameElement_) + 2 * Blockly.BlockSvg.INLINE_PADDING_Y : this.EVENT_NAME_WIDTH);
            let eventValueWidth = this.valueInputType_ === null ? 0 : Math.max(this.EVENT_VALUE_WIDTH, this.eventValueElement_ ? Blockly.Field.getCachedWidth(this.eventValueElement_) + 2 * Blockly.BlockSvg.INLINE_PADDING_Y : this.EVENT_VALUE_WIDTH);
            this.eventNameRect_ && (this.eventNameRect_.setAttribute("width", eventNameWidth));
            this.eventValueRect_ && (this.eventValueRect_.setAttribute("width", eventValueWidth));
            this.eventValueGroup_ && (this.eventValueGroup_.setAttribute("transform", "translate(" + (eventNameWidth + Blockly.BlockSvg.SEP_SPACE_X) + ",0)"));
            this.size_.width = eventNameWidth + Blockly.BlockSvg.SEP_SPACE_X + eventValueWidth;
        }
        Blockly.RobotEventField.prototype.setValue = function (value = "") {
            if (!this.editing_) {
                let eventName = value.split(",")[0];
                this.updateValueInputType_(eventName);
            } else if (this.editing_ === "name") {
                this.updateValueInputType_(value);
                if (this.valueInputType_ === null) {
                    value = value + "," + (this.valueStorage_[value] || "");
                } else if (this.valueInputType_ === "input") {
                    value = value + "," + (this.valueStorage_[value] || "");
                } else if (this.valueInputType_ === "select") {
                    value = value + "," + (this.valueStorage_[value] || "");
                }
            } else if (this.editing_ === "value") {
                value = this.eventName_ + "," + value;
            }
            value = this.validateValue_(value);
            let { eventNameValue = "", eventNameLabel = "", eventValueValue = "", eventValueLabel = "" } = value;
            let text = [eventNameValue, eventValueValue].join(",");
            if (this.sourceBlock_ && Blockly.Events.isEnabled()) {
                Blockly.Events.fire(new Blockly.Events.BlockChange(this.sourceBlock_, "field", this.name, [this.eventName_, this.eventValue_].join(","), text));
            }
            this.eventName_ = eventNameValue;
            this.eventValue_ = eventValueValue;
            this.eventNameLabel_ = eventNameLabel;
            this.eventValueLabel_ = eventValueLabel;
            this.valueStorage_[this.eventName_] = this.eventValue_;
            this.render_();
        };
        Blockly.RobotEventField.prototype.getValue = function () {
            let { eventName_, eventValue_ } = this;
            let valueArr = [eventName_];
            this.valueInputType_ !== null && valueArr.push(eventValue_);
            return valueArr.join(",");
        };
        Blockly.RobotEventField.prototype.updateValueInputType_ = function (eventName) {
            let options = Blockly.RobotEventField.OPTIONS;
            this.eventNameConfig_ = options.find(item => item.value === eventName) || (options.filter(item => !["nuwa_menu_title", "nuwa_menu_small"].includes(item[1]) && typeof item[1] !== "function"))[0];
            this.valueInputType_ = this.eventNameConfig_.type || null;
        };
        Blockly.RobotEventField.prototype.validateValue_ = function (value) {
            value = value.split(",");
            let obj = {};
            obj.eventNameValue = this.eventNameConfig_.value;
            obj.eventNameLabel = this.eventNameConfig_.label;
            this.valueInputType_ = this.eventNameConfig_.type;
            if (this.valueInputType_ === null) {
                obj.eventValueValue = "";
                obj.eventValueLabel = "";
                this.eventValueOptions_ = null;
            } else if (this.valueInputType_ === "input") {
                obj.eventValueValue = value[1];
                obj.eventValueLabel = value[1].replace(/^[\"\'](.*)[\"\']$/, "$1");
                this.eventValueOptions_ = null;
            } else if (this.valueInputType_ === "select") {
                let valueOptions = this.eventValueOptions_ = this.eventNameConfig_.options || [];
                let eventValueOption = valueOptions.find(item => item[1] === value[1]) || (valueOptions.filter(item => !["nuwa_menu_title", "nuwa_menu_small"].includes(item[1]) && typeof item[1] !== "function"))[0];
                obj.eventValueValue = eventValueOption ? eventValueOption[1] : "";
                obj.eventValueLabel = eventValueOption ? eventValueOption[0].alt || "" : "";
            }
            return obj;
        };
        Blockly.RobotEventField.prototype.getLabel = function () {
            let { eventNameLabel_, eventValueLabel_ } = this;
            var maxDisplayLength = this.maxDisplayLength
            if(eventValueLabel_.length > maxDisplayLength){
                eventValueLabel_ = eventValueLabel_.substring(0, maxDisplayLength - 2) + "\u2026"
                eventValueLabel_ = eventValueLabel_.replace(/\s/g, Blockly.Field.NBSP);
                this.sourceBlock_.RTL && (eventValueLabel_ += "\u200f");
            }
            return [eventNameLabel_, eventValueLabel_];
        };
        Blockly.RobotEventField.prototype.showEventNameSelect = function (e) {
            this.menuGenerator_ = this.getEventNameSelectOptions();
            this.borderRect_ = this.eventNameRect_;
            this.text_ = this.value_ = this.eventName_;
            this.editing_ = "name";
            Blockly.FieldDropdown.prototype.showEditor_.call(this, goog.userAgent.MOBILE || goog.userAgent.ANDROID || goog.userAgent.IPAD);
        };
        Blockly.RobotEventField.prototype.onEventValueClick = function (e) {
            this.borderRect_ = this.eventValueRect_;
            this.editing_ = "value";
            if (this.valueInputType_ === "input") {
                this.text_ = this.eventValueLabel_;
                Blockly.FieldTextInput.prototype.showEditor_.call(this);
            } else if(this.valueInputType_ === "select") {
                this.text_ = this.value_ = this.eventValue_;
                this.menuGenerator_ = this.getEventValueOptions();
                Blockly.FieldDropdown.prototype.showEditor_.call(this, goog.userAgent.MOBILE || goog.userAgent.ANDROID || goog.userAgent.IPAD);
                // 注入更新家人按鈕
                if(this.SHOW_ROBOT_FAMILIES && this.eventName_ === "MCFaceRecognitionAction"){
                    let myFamilyTitle = Blockly.WidgetDiv.DIV.querySelector(".nuwaBLocklyDropdown.blocklyDropdownMenu .goog-menuitem.goog-menu-title .goog-menuitem-content");
                    if(myFamilyTitle){
                        let updateButton = document.createElement("span");
                        updateButton.textContent = Blockly.utils.replaceMessageReferences("%{BKY_NUWA_UPDATE_FAMILIES}");
                        updateButton.className = "update-families";
                        updateButton.onclick = () => {
                            Blockly.WidgetDiv.hide();
                            Blockly.getRobotFamily();
                        };
                        myFamilyTitle.appendChild(updateButton);
                    }
                }
            }
        };
        Blockly.RobotEventField.prototype.showInlineEditor_ = Blockly.FieldTextInput.prototype.showInlineEditor_;
        Blockly.RobotEventField.prototype.widgetDispose_ = function () {
            Blockly.FieldTextInput.prototype.widgetDispose_.call(this);
        };
        Blockly.RobotEventField.prototype.validate_ = Blockly.FieldTextInput.prototype.validate_;
        Blockly.RobotEventField.prototype.resizeEditor_ = Blockly.FieldTextInput.prototype.resizeEditor_;
        Blockly.RobotEventField.prototype.bindEvents_ = function (a) {
            a.onKeyDownWrapper_ = Blockly.bindEventWithChecks_(a, "keydown", this, this.onHtmlInputKeyDown_);
            a.onKeyUpWrapper_ = Blockly.bindEventWithChecks_(a, "keyup", this, this.onHtmlInputChange_);
            a.onKeyPressWrapper_ = Blockly.bindEventWithChecks_(a, "keypress", this, this.onHtmlInputChange_);
        };
        Blockly.RobotEventField.prototype.showPromptEditor_ = Blockly.FieldTextInput.prototype.showPromptEditor_;
        Blockly.RobotEventField.prototype.showPromptEditor_ = Blockly.FieldTextInput.prototype.showPromptEditor_;
        Blockly.RobotEventField.prototype.onHtmlInputKeyDown_ = Blockly.FieldTextInput.prototype.onHtmlInputKeyDown_;
        Blockly.RobotEventField.prototype.onHtmlInputChange_ = Blockly.FieldTextInput.prototype.onHtmlInputChange_;
        Blockly.RobotEventField.prototype.maybeSaveEdit_ = Blockly.FieldTextInput.prototype.maybeSaveEdit_;
        Blockly.RobotEventField.prototype.unbindEvents_ = Blockly.FieldTextInput.prototype.unbindEvents_;
        Blockly.RobotEventField.prototype.getEventNameSelectOptions = function () {
            return Blockly.RobotEventField.OPTIONS.map(item => {
                return [item.label, item.value];
            });
        };
        Blockly.RobotEventField.prototype.getEventValueOptions = function () {
            let eventNameConfig = Blockly.RobotEventField.OPTIONS.find(item => item.value === this.eventName_);
            if (eventNameConfig && eventNameConfig.type === "select") {
                //當前事件為機器人看到時
                let options = []
                if(this.eventName_ === 'MCFaceRecognitionAction'){
                    if(this.SHOW_ROBOT_FAMILIES){
                        // 如果顯示機器人家人清單，推入默認的機器人家人清單選項
                        if(eventNameConfig.options.length === 0){
                            //如果機器人家人清單為空，添加提示
                            options = [this.ROBOT_FAMILY_OPTION, this.ROBOT_FAMILY_EMPTY_TIP]
                        } else {
                            options = [this.ROBOT_FAMILY_OPTION, ...eventNameConfig.options]
                        }
                    } else {
                        //如果不顯示機器人家人清單，則顯示臨時自定義家人
                        if(this.SHOW_MULTI_ROBOTS_TIP){
                            // 如果顯示多台機器人連線提示
                            options = [this.TEMP_FAMILY_OPTION, this.MULTI_ROBOTS_TIP, this.ADD_FAMILY_BUTTON, ...eventNameConfig.options]
                        } else {
                            //不顯示多台機器人連線提示
                            options = [this.TEMP_FAMILY_OPTION, this.ADD_FAMILY_BUTTON, ...eventNameConfig.options]
                        }
                        
                    }
                } else {
                    options = eventNameConfig.options;
                }
                return options;
            }
            return [];
        };
    })();
    //动态下拉列表
    (function dynamicDropdown(){
        Blockly.FieldDynamicDropdown = function(options, b){
            if(typeof options === "function"){
                this.optionsFunc = options;
                if(this.optionsFunc && typeof this.optionsFunc === "function"){
                    Blockly.FieldDynamicDropdown.superClass_.constructor.call(this, [["", ""]], b);
                    options = this.optionsFunc(this);
                    if(options instanceof Promise){
                        this.asyncOption_ = true;
                        this.optionsInited_ = false;
                        options.then(res => {
                            this.setOptions(res);
                        })
                    } else {
                        this.setOptions(options);
                    }
                }
            } else {
                Blockly.FieldDynamicDropdown.superClass_.constructor.call(this, options, b);
                this.setOptions(options);
            }
        }
        
        goog.inherits(Blockly.FieldDynamicDropdown, Blockly.FieldDropdown);
        Blockly.FieldDynamicDropdown.fromJson = function(a){
            let dropdown = new Blockly.FieldDynamicDropdown(a.options);
            let placeholder_ = Blockly.utils.replaceMessageReferences(a.placeholder || "%{BKY_NUWA_DROPDOWN_PLACEHOLDER}");
            dropdown.placeholder_ = placeholder_;
            if(!dropdown.text_){
                dropdown.text_ = placeholder_;
            }
            return dropdown;
        };
        Blockly.FieldDynamicDropdown.CHECKMARK_OVERHANG=25;
        Blockly.FieldDynamicDropdown.MAX_MENU_HEIGHT_VH=.45;
        Blockly.FieldDynamicDropdown.ARROW_CHAR=goog.userAgent.ANDROID?"\u25bc":"\u25be";
        Blockly.FieldDynamicDropdown.prototype.setOptions = function(options){
            Blockly.FieldDropdown.validateOptions_(options);
            this.menuGenerator_ = options;
            this.optionsInited_ = true;
            if(this.asyncSetValue_ && typeof this.asyncSetValue_ === "function"){
                this.asyncSetValue_.call(this);
            }
        };
        Blockly.FieldDynamicDropdown.prototype.setValue = function (a) {
            if(!this.asyncOption_ || this.optionsInited_){
                this.asyncSetValue_ = null;
                Blockly.FieldDynamicDropdown.superClass_.setValue.call(this, a);
            } else {
                this.asyncSetValue_ = function(){
                    this.setValue(a);
                }
            }
        };
        Blockly.FieldDynamicDropdown.prototype.showEditor_ = function(){
            if(this.optionsFunc && typeof this.optionsFunc === "function"){
                let options = this.optionsFunc(this);
                if(options instanceof Promise){
                    options.then(res => {
                        this.setOptions(res);
                        Blockly.FieldDynamicDropdown.superClass_.showEditor_.call(this);
                    })
                } else {
                    this.setOptions(options);
                    Blockly.FieldDynamicDropdown.superClass_.showEditor_.call(this);
                }
            } else {
                Blockly.FieldDynamicDropdown.superClass_.showEditor_.call(this);
            }
        }
        Blockly.Field.register("field_dynamic_dropdown", Blockly.FieldDynamicDropdown);
    })();
    // 调整气泡框关闭逻辑
    (function iconBubble(){
        Blockly.Icon.prototype.iconPool = []
        Blockly.Icon.prototype.createIcon = function() {
            if(!this.iconGroup_){
                this.iconGroup_ = Blockly.utils.createSvgElement("g", {
                    "class": "blocklyIconGroup"
                }, null)
                this.block_.isInFlyout && Blockly.utils.addClass(this.iconGroup_, "blocklyIconGroupReadonly")
                this.drawIcon_(this.iconGroup_)
                this.block_.getSvgRoot().appendChild(this.iconGroup_)
                Blockly.bindEventWithChecks_(this.iconGroup_, "mouseup", this, this.iconClick_)
                this.updateEditable()
            }
            Blockly.Icon.prototype.iconPool.push(this)
        };
        Blockly.Icon.prototype.hideBubble_=function(a){
            let target = a.target
            Blockly.Icon.prototype.iconPool.forEach(icon => {
                if(!icon.isVisible()){
                    return
                }
                // 是否点击到本身的icon
                let isInSelfIconGroup = isParent(target, icon.iconGroup_)
                let isInIconGroup = isIconGroup(target)
                if(!isInSelfIconGroup && (target.classList.contains('blocklyMainBackground') || isInIconGroup)){
                    icon.setVisible(false)
                }
            })
        };
        // 解決在ipad safari comment輸入框無法獲取焦點的問題
        Blockly.Comment.prototype.textareaFocus_ = function(a) {
            this.bubble_.promote_();
            this.textarea_.focus();
        }
    })();
    //样式调整
    if(!document.querySelector("#nuwa-blockly-custom-style")){
        let style = document.createElement("style");
        style.type = "text/css";
        style.id="nuwa-blockly-custom-style"
        style.innerHTML = '.blocklyError>.blocklyPath{stroke:red;stroke-width:3px}.blocklyError>.blocklyPathLight{display:none}.blocklyText{fill:#000000}.blocklyText.media-name{fill:#333333;font-size:12px;}.blocklyNonEditableText>text,.blocklyEditableText>text{fill:#4a4a4a}.blocklyNonEditableText>rect,.blocklyEditableText>rect{fill:#ffffff;fill-opacity:0.8}.blocklyWidgetDiv{z-index:1000}.blocklyWidgetDiv .goog-menu,.blocklyDropDownDiv .goog-menu{z-index:1000}.blocklyWidgetDiv .blocklyDropdownMenu.nuwaBLocklyDropdown{border-radius:6px;padding:12px 0!important;border:none;box-shadow:0 -3px 10px 0 rgba(0, 0, 0, 0.3)}.blocklyWidgetDiv ::-webkit-scrollbar-thumb{background-color:rgba(0,0,0,0.4)}.blocklyWidgetDiv ::-webkit-scrollbar-track{background-color:transparent;box-shadow:none}.blocklyWidgetDiv .nuwaDropdownArrow{position:absolute;width:8px;height:0px;border:8px solid transparent;z-index:20001}.blocklyWidgetDiv .blocklyDropdownMenu.nuwaBLocklyDropdown .goog-menuitem.goog-menu-title .goog-menuitem-content{font-weight:bold}.blocklyWidgetDiv .blocklyDropdownMenu.nuwaBLocklyDropdown .goog-menuitem.goog-menu-title .goog-menuitem-content .update-families{position:absolute;right:24px;font-size:14px;font-weight:normal;color:#333333;text-decoration:underline;vertical-align:middle;cursor:pointer}.blocklyWidgetDiv .blocklyDropdownMenu.nuwaBLocklyDropdown .goog-menuitem.goog-menu-title .goog-menuitem-content .update-families:hover{color:#666666}.blocklyWidgetDiv .blocklyDropdownMenu.nuwaBLocklyDropdown .goog-menuitem.goog-menu-title .goog-menuitem-content .update-families:active{opacity:0.7}.blocklyWidgetDiv .blocklyDropdownMenu.nuwaBLocklyDropdown .goog-menuitem.goog-menu-small .goog-menuitem-content{font-size:12px;white-space:normal;line-height:1.75em;padding-top:8px;padding-bottom:8px}.blocklyWidgetDiv .blocklyDropdownMenu.nuwaBLocklyDropdown .goog-menuitem:not(.goog-menu-title):not(.goog-menu-small):hover,.blocklyWidgetDiv .blocklyDropdownMenu.nuwaBLocklyDropdown .goog-menuitem:not(.goog-menu-title):not(.goog-menu-small).goog-menuitem-highlight{background:rgba(255,255,255,0.3);border-color:transparent}.blocklyWidgetDiv .goog-menu-title{min-width:160px;}.blocklyWidgetDiv .blocklyDropdownMenu.nuwaBLocklyDropdown .goog-menuitem.goog-menu-title.goog-menuitem-highlight,.blocklyWidgetDiv .blocklyDropdownMenu.nuwaBLocklyDropdown .goog-menuitem.goog-menu-small.goog-menuitem-highlight{background:transparent;border-color:transparent}.blocklyWidgetDiv .goog-menuitem-content,.blocklyDropDownDiv .goog-menuitem-content{position:relative}.blocklyWidgetDiv .goog-option-selected .goog-menuitem-checkbox,.blocklyWidgetDiv .goog-option-selected .goog-menuitem-icon,.blocklyDropDownDiv .goog-option-selected .goog-menuitem-checkbox,.blocklyDropDownDiv .goog-option-selected .goog-menuitem-icon{top:50%;position:absolute;margin-top:-8px}.nuwaBLocklyDropdown .nuwaBlocklyDropItemContent{display:inline-block;padding-right:18px}.nuwaBLocklyDropdown img{vertical-align:middle;object-fit:scale-down}.nuwaBlocklyDropItemContent .item-image{vertical-align:middle}.nuwaBlocklyDropItemContent .nuwaDropdownItemLabel{line-height:24px;vertical-align:middle;padding-left:12px}.nuwaBlocklyDropItemContent .nuwaDropdownItemFunc{display:block;width:18px;height:18px;position:absolute;top:16px;right:0px;line-height:0;color:#666666;cursor:pointer}.nuwaBlocklyDropItemContent .nuwaDropdownItemFunc svg{fill:#666666}.nuwaBlocklyDropItemContent .nuwaDropdownItemFunc:hover{color:#333333}.nuwaBlocklyDropItemContent .nuwaDropdownItemFunc:hover svg{fill:#333333}.blocklyJointAngle{position:relative;display:inline-block;margin-left:55px}.blocklyJointAngle>div img{width:100%;height:100%;display:block;-webkit-user-drag:none;pointer-events:none;}.BlocklyJointAngleBg{width:100%;height:100%}.BlocklyJointAngleSymbol{position:absolute;width:200px;height:200px;border-radius:100px;overflow:visible;cursor:pointer;left:0;top:0;z-index:1}.jointAngleLimiter{position:absolute;left:0;top:0;z-index:-1;fill:#ecf148;fill-opacity:0.6;pointer-events:none;}.blocklyDropDownDiv.nuwaColourPicker{border-radius:6px;box-shadow:0 -3px 10px 0 rgba(0, 0, 0, 0.3), inset 1px 1px 2px 0 rgba(255, 255, 255, 0.5), inset -1px -1px 2px 0 rgba(0, 0, 0, 0.5)}.blocklyDropDownContent{background-color:inherit}.nuwaColourPicker .blocklyDropDownArrow.arrowTop{top:1px;border:none;box-shadow:0 -3px 10px 0 rgba(0, 0, 0, 0.3), inset 1px 1px 2px 0 rgba(255, 255, 255, 0.5)}.blocklyColourTable.defaultTable,.blocklyColourTable.customTable{width:224px;overflow:hidden}.blocklyColourTable.defaultTable{padding:8px 12px}.blocklyColourTable.customTable{padding:12px 16px;border-top:1px solid #000000}.blocklyColourTable>ul{width:100%;overflow:hidden}.blocklyColourTable>ul>li{padding:5px;border:none;float:left}.blocklyColourTable .colourpickerItem{background-color:rgba(255,255,255,0.2);transform-origin:center center;border:none}.blocklyColourTable .colourpickerItem>div{background-repeat:no-repeat;background-position:center center;background-size:12px 12px}.blocklyColourTable.defaultTable .colourpickerItem{width:30px;height:30px;border-radius:15px;padding:3px}.defaultTable .colourpickerItem>div{width:100%;height:100%;border-radius:50%}.blocklyColourTable.customTable .colourpickerItem{width:20px;height:20px;border-radius:6px;padding:2px}.customTable .colourpickerItem>div{width:100%;height:100%;border-radius:4px}.blocklyColourTable.customTable>ul>li{padding:2px}.blocklyColourTable .colourpickerItem:hover{transform:scale(1.1);background-color:rgba(255,255,255,0.8)}.blocklyColourTable .colourpickerItem.blocklyColourSelected>div{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAQpJREFUOBHlkb1Kw1AYhs/JUEToJp06CN3s4uAdiKteQOeKg0MpuDm0e5HSQgfxOpycnQJegXSwU11cUloQ4/MmJ8mRZkgHp37wnO/3/ZKcGLN/FsfxKYzgUl9vd7kCRGfMT6AG33AecFQyxG0GH0Bi2bu1NkoW0LyAIZykvb8n9RaVKRy6zif+TrGlqeILaPMaemwO8YnRbxI8wVFaMV/4LjNz5QHBCv+hBDuAMSJ9q8E3cDPIxBHxbSYmTi/RPeWRXAKZ3mQAN3AMsg1I/JZk7sj/QskSf0433kf86hcV53+B5oL8GpZqePZDfF8m9maKUG8CzxA6ropuxchb0qko2R5jSX27+g+VX5yWbKIP0DdRAAAAAElFTkSuQmCC);border:none!important}.blocklyColourSelected,.blocklyColourSelected:hover{border:none!important}.blocklyWidgetDiv .blocklyHtmlInput{padding:1px 5px;margin-top:1px}.blocklySelected>.blocklyPath{stroke:#ffffff}.bloclyActive>.blocklyPath{stroke:#ffffff;stroke-width:3}.bloclyActive>.blocklyPathLight{display:none}.blocklyEditableText.nuwa_disabled{cursor:default !important;pointer-events:none;}.blocklyEditableText.nuwa_disabled>rect{fill: none;}.blocklyMinimalBody{background: none;left: auto;top: auto;}';
        document.head.appendChild(style);
    }
}

Blockly.Css.inject=function(a,b){if(!Blockly.Css.styleSheet_){var c=".blocklyDraggable {}\n";a&&(c+=Blockly.Css.CONTENT.join("\n"),Blockly.FieldDate&&(c+=Blockly.FieldDate.CSS.join("\n")));Blockly.Css.mediaPath_=b.replace(/[\\\/]$/,"");c=c.replace(/<<<PATH>>>/g,Blockly.Css.mediaPath_);a=document.createElement("style");a.id="blockly-css-style";document.head.insertBefore(a,document.head.firstChild);c=document.createTextNode(c);a.appendChild(c);Blockly.Css.styleSheet_=a.sheet}}